import { MEMBERSHIP_SEASON } from '../config/membershipSeason';
import { MEMBER_ACTIVE_SEASONS, getActiveSeasonsFromUser } from './memberStatus';

export const MEMBERSHIP_FLAG_KEYS = [
  'star',
  'starAboClub',
  'base',
  'plus',
  'abonnePlus',
  'plusU14',
  'standard',
  'abonneStandard',
  'abonnes',
  'nonAbonne',
  'newsletter',
  'under5',
  'jofcAdult',
  'jofcUnder14',
  'jofcUnder5',
  'jofcAbonnesFull',
];

export const EXCEL_SEASON_MEMBERSHIP_FIELDS = [
  { key: 'star', label: 'Abonné STAR' },
  { key: 'starAboClub', label: 'Abonné STAR abo club' },
  { key: 'base', label: 'Abonné BASE' },
  { key: 'plus', label: 'Membre PLUS' },
  { key: 'abonnePlus', label: 'Abonné membre PLUS' },
  { key: 'plusU14', label: 'Membre UNDER14' },
  { key: 'standard', label: 'Membre STANDARD' },
  { key: 'abonneStandard', label: 'Abonné membre STANDARD' },
  { key: 'abonnes', label: 'Abonné FULL' },
  { key: 'jofcAbonnesFull', label: 'JOFC Abonné FULL' },
  { key: 'nonAbonne', label: 'Non Abonné' },
  { key: 'newsletter', label: 'Newsletter' },
  { key: 'under5', label: 'Membre UNDER5' },
];

export const JOFC_SEASON_MEMBERSHIP_FIELDS = [
  { key: 'jofcAdult', label: 'JOFC Adult' },
  { key: 'jofcUnder14', label: 'JOFC under 14' },
  { key: 'jofcUnder5', label: 'JOFC Under 5' },
  { key: 'base', label: 'Abonné BASE' },
  { key: 'jofcAbonnesFull', label: 'Abonné FULL' },
  { key: 'star', label: 'Abonné STAR' },
  { key: 'starAboClub', label: 'Abonné STAR abo club' },
  { key: 'newsletter', label: 'Newsletter' },
];

export function emptyMembershipFlags() {
  const flags = {};
  for (const key of MEMBERSHIP_FLAG_KEYS) {
    flags[key] = false;
  }
  return flags;
}

export function buildEmptyMembershipFlagsBySeason() {
  const bySeason = {};
  for (const season of MEMBER_ACTIVE_SEASONS) {
    bySeason[season] = emptyMembershipFlags();
  }
  return bySeason;
}

function mapLikeToObject(value) {
  if (!value) return {};
  if (value instanceof Map) return Object.fromEntries(value);
  if (typeof value === 'object') return { ...value };
  return {};
}

function flagsToPlainObject(value) {
  if (!value || typeof value !== 'object') return emptyMembershipFlags();
  const out = emptyMembershipFlags();
  for (const key of MEMBERSHIP_FLAG_KEYS) {
    if (typeof value[key] === 'boolean') {
      out[key] = value[key];
    }
  }
  return out;
}

function hasAnyTrueFlag(flags) {
  return MEMBERSHIP_FLAG_KEYS.some((key) => flags[key] === true);
}

function membershipFlagsBySeasonHasData(bySeasonObj) {
  return Object.values(bySeasonObj).some((flags) => hasAnyTrueFlag(flags));
}

export function getMembershipFlagsForSeason(user, season) {
  if (!user || !season) return emptyMembershipFlags();

  const bySeason = mapLikeToObject(user.membershipFlagsBySeason);
  const seasonFlags = bySeason[season];

  if (seasonFlags && typeof seasonFlags === 'object') {
    return flagsToPlainObject(seasonFlags);
  }

  const flat = flagsToPlainObject(user.membershipFlags);

  if (!membershipFlagsBySeasonHasData(bySeason)) {
    const crmSeason = user.season && String(user.season).trim();
    if (crmSeason === season) {
      return flat;
    }
    const active = getActiveSeasonsFromUser(user);
    if (active.includes(season) && active.length === 1 && !crmSeason) {
      return flat;
    }
  }

  return emptyMembershipFlags();
}

export function buildMembershipFlagsBySeasonFromUser(user) {
  const bySeason = {};
  for (const season of MEMBER_ACTIVE_SEASONS) {
    bySeason[season] = getMembershipFlagsForSeason(user, season);
  }
  return bySeason;
}

export function getMembershipFieldsForSeason(season) {
  if (season === MEMBERSHIP_SEASON) {
    return JOFC_SEASON_MEMBERSHIP_FIELDS;
  }
  return EXCEL_SEASON_MEMBERSHIP_FIELDS;
}

export function mergeJofcFlagsIntoSeasonFlags(existingFlags, jofcTypeKey) {
  const flags = { ...flagsToPlainObject(existingFlags) };
  flags.jofcAdult = jofcTypeKey === 'jofcAdult';
  flags.jofcUnder14 = jofcTypeKey === 'jofcUnder14';
  flags.jofcUnder5 = jofcTypeKey === 'jofcUnder5';
  return flags;
}

export function buildJofcMembershipFlags(activeKey) {
  return {
    jofcAdult: activeKey === 'jofcAdult',
    jofcUnder14: activeKey === 'jofcUnder14',
    jofcUnder5: activeKey === 'jofcUnder5',
  };
}
